export enum CUSTOM_EVENTS {
    FAI_COMPARATOR_SELECTION = 'faiComparatorSelection',
}

export enum TECHNOLOGY {
    FTTH = 'FTTH',
    BOX_4G = 'BOX_4G',
    BOX_5G = 'BOX_5G',
}

/* eslint-disable @typescript-eslint/naming-convention */
export enum PLAY {
    _2P = '2P',
    _3P = '3P',
}

export enum CATEGORY_TYPE {
    GP = 'offre_gp',
    PRO = 'offre_pro',
    OLD = 'offre_old',
}

export enum ERROR_CONTEXT {
    ERROR = 'error',
    NO_OFFER = 'no_offer',
    MISMATCH_CONFIG = 'mismatch_config',
}

export const PATTERNS = {
    POSTAL_CODE: /^\d{5}$/,
    STREET_NUMBER: /^\d+[A-Za-z]?$/,
    CLEAN_STREETS: /LIEU DIT |AU |AUX |DE |DES |DU |D |LE |LA |L |LES /gi,
    NAME: /^[a-zA-Z-'` ÀÂÄÇÈÉÊËÎÏÔÖÙÛÜàáâäçèéêëîïôöùûü]+$/,
    PHONE: /^0[1-7|9]\d{8}$/,
};

export enum BUTTON_STYLE {
    PRIMARY = 'is-primary',
    SECONDARY = 'is-secondary',
}

export enum ELIGIBILITY_JOURNEY {
    DEFAULT = 'default',
    PROMO = 'promo',
    PROMO_PRIVEE = 'promo_privee',
    MIXED_CART = 'mixed_cart',
    SMART_TV = 'smart_tv',
    GAMING = 'gaming',
    TABLET = 'tablet',
    MOINS_26_ANS = 'moins_26_ans',
    BANK = 'bank',
    EXTRA_BBOX = 'extra_bbox',
    LM = 'lm',
}

export enum ELIGIBILITY_STORAGE_KEY {
    SUMMARY = 'provider_summary',
    RESULTS = 'provider_results',
    ADDRESS = 'provider_address',
    MODE = 'provider_eligibility_mode',
    PACK_PRODUCT = 'provider_pack_product',
    REFERER = 'provider_results_referer',
    YAMA_CART = 'yama_cart',
    FAI_COMPARATOR_SELECTION = 'faiComparatorSelection',
    LM_PARTNER = 'provider_lm_partner',
}
